import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class ApplicationStateService {
    private changedSubject = new BehaviorSubject<boolean>(false);
    changed$ = this.changedSubject.asObservable().pipe(
        debounceTime(500) // prevent rapid update API
    );

    setChanged() {
        this.changedSubject.next(true); // Notify subscribers that a change occurred
    }

    resetChanged() {
        this.changedSubject.next(false); // Reset state
    }
}
